import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store/index.js';

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    component:  () => import('../components/Layouts/AppLayout.vue'),
    meta: {requiresAuth: true, roles: [1]},
    children: [
      {
        path: '',
        name: 'home',
        meta: {requiresAuth: true, roles: [1]},
        component: () => import('../views/HomeView.vue'),
      },
    ],
  },
  {
    path: '/login',
    component: () => import('../components/Layouts/PublicLayout.vue'),
    meta: { guest: true },
    children: [
      {
        path: '',
        name: 'login',
        meta: { guest: true },
        component: () => import('../views/LoginView.vue'),
      },
    ],
  },
  {
    path: '/accounts',
    component: () => import('../components/Layouts/AppLayout.vue'),
    meta: {requiresAuth: true, roles: [1, 2]},
    children: [
      {
        path: '',
        name: 'accounts',
        meta: {requiresAuth: true, roles: [1, 2]},
        component: () => import('../views/AccountsView.vue'),
      },
    ],
  },
  {
    path: '/apk',
    component: () => import('../components/Layouts/AppLayout.vue'),
    meta: {requiresAuth: true, roles: [1, 2]},
    children: [
      {
        path: '',
        name: 'apk',
        meta: {requiresAuth: true, roles: [1, 2]},
        component: () => import('../views/APKView.vue'),
      },
    ],
  },
  {
    path: '/natcash-test',
    component: () => import('../components/Layouts/AppLayout.vue'),
    meta: {requiresAuth: true, roles: [1]},
    children: [
      {
        path: '',
        name: 'natcash-test',
        meta: {requiresAuth: true, roles: [1]},
        component: () => import('../views/NatcashTestView.vue'),
      },
    ],
  },
  {
    path: '/accounts/:id',
    component:  () => import('../components/Layouts/AppLayout.vue'),
    meta: {requiresAuth: true, roles: [1, 2]},
    children: [
      {
        path: '',
        name: 'account-details',
        meta: {requiresAuth: true, roles: [1, 2]},
        component: () => import('../views/AccountDetails/AccountDetailsView.vue'),
      },
    ],
  },
  {
    path: '/subscriptions',
    component: () => import('../components/Layouts/AppLayout.vue'),
    meta: {requiresAuth: true, roles: [1, 2]},
    children: [
      {
        path: '',
        name: "subscriptions",
        meta: {requiresAuth: true, roles: [1, 2]},
        component: () => import('../views/SubscriptionsView.vue'),
      },
    ],
  },
  {
    path: '/renewals',
    component: () => import('../components/Layouts/AppLayout.vue'),
    meta: { requiresAuth: true, roles: [1] },
    children: [
      {
        path: '',
        component: () => import('../views/renewals/RenewalsLayout.vue'),
        meta: { requiresAuth: true, roles: [1] },
        redirect: { name: 'renewals-paiements-plan' },
        children: [
          {
            path: 'plans-utilisation',
            name: 'renewals-plans-utilisation',
            meta: { requiresAuth: true, roles: [1] },
            component: () => import('../views/renewals/RenewalsGlobalPlansView.vue'),
          },
          {
            path: 'paiements-plan',
            name: 'renewals-paiements-plan',
            meta: { requiresAuth: true, roles: [1] },
            component: () => import('../views/renewals/RenewalsUsagePaymentsView.vue'),
          },
          {
            path: 'plans-fonctionnalites',
            name: 'renewals-plans-fonctionnalites',
            meta: { requiresAuth: true, roles: [1] },
            component: () => import('../views/renewals/RenewalsFeaturePlansView.vue'),
          },
          {
            path: 'paiements-fonctionnalites',
            name: 'renewals-paiements-fonctionnalites',
            meta: { requiresAuth: true, roles: [1] },
            component: () => import('../views/renewals/RenewalsFeaturePaymentsView.vue'),
          },
        ],
      },
    ],
  },
  {
    path: '/referral',
    component: () => import('../components/Layouts/AppLayout.vue'),
    meta: {requiresAuth: true, roles: [1]},
    children: [
      {
        path: '',
        name: 'referral',
        meta: {requiresAuth: true, roles: [1]},
        component: () => import('../views/ReferralRewardsView.vue'),
      },
    ],
  },
  {
    path: '/referrers',
    component: () => import('../components/Layouts/AppLayout.vue'),
    meta: {requiresAuth: true, roles: [1]},
    children: [
      {
        path: '',
        name: 'referrers',
        meta: {requiresAuth: true, roles: [1]},
        component: () => import('../views/ReferrersView.vue'),
      },
    ],
  },
  {
    path: '/onboarding',
    component: () => import('../components/Layouts/AppLayout.vue'),
    meta: {requiresAuth: true, roles: [1]},
    children: [
      {
        path: '',
        name: 'onboarding',
        meta: {requiresAuth: true, roles: [1]},
        component: () => import('../views/OnboardingView.vue'),
      },
    ],
  },
  {
    path: '/settings',
    component: () => import('../components/Layouts/AppLayout.vue'),
    meta: {requiresAuth: true, roles: [1]},
    children: [
      {
        path: '',
        name: 'settings',
        meta: {requiresAuth: true, roles: [1]},
        component: () => import('../views/SettingsView.vue'),
      },
    ],
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  if(to.matched.some(record => record.meta.requiresAuth)) {
    if (store.getters.isAuthenticated) {
      // Vérifier les rôles
      const user = store.getters.StateUser
      const userRoleId = user?.role_id || 1
      const routeRoles = to.meta.roles
      
      if (routeRoles && !routeRoles.includes(userRoleId)) {
        // Rediriger vers la première page autorisée
        if (userRoleId === 2) {
          next('/accounts')
        } else {
          next('/')
        }
        return
      }
      
      next()
      return
    }
    next('/login')
  } else {
    next()
  }
})

router.beforeEach((to, from, next) => {
  if (to.matched.some((record) => record.meta.guest)) {
    if (store.getters.isAuthenticated) {
      // Rediriger selon le rôle
      const user = store.getters.StateUser
      const userRoleId = user?.role_id || 1
      if (userRoleId === 2) {
        next("/accounts");
      } else {
        next("/");
      }
      return;
    }
    next();
  } else {
    next();
  }
});

export default router
